import i18next from 'i18next';
import moment from 'moment';
import FileSaver from 'file-saver';
import { paymentApi } from 'services/http';
import { localAppointmentsFilters } from '../services/appointments';

const getPractitionerName = pr => {
  if (pr && Array.isArray(pr.localizations)) {
    const localization = pr.localizations.find(e => e.lang === i18next.language);
    return (localization && localization.name) || pr.localizations[0].name;
  }
  return null;
};

export const generateStatusList = ['error', 'inProgress', 'success'];

export const prepareDataForFilter = initData => {
  const {
    practitionersList,
    campusesList,
    defaultCampusId,
    defaultPractitionerId,
    defaultDate
  } = initData;

  if (practitionersList && campusesList) {
    const parseCampuses = campusesList
      .filter(el => el.id)
      .sort((a, b) => a.name && b.name && a.name - b.name);

    // campus
    const locCampusId = localAppointmentsFilters.get('campusId');
    let defaultCampus;
    if (locCampusId) {
      defaultCampus =
        Array.isArray(parseCampuses) && parseCampuses.find(el => el.id === locCampusId);
    } else {
      defaultCampus =
        Array.isArray(parseCampuses) &&
        parseCampuses.find(el => el.name && el.name.match(/deurne/i));
    }

    const addPractitionerLocalization = practitionersList.map(el => {
      el['name'] = getPractitionerName(el);
      return el;
    });

    return {
      reportType: {
        id: 'reportType',
        translateLabelKey: 'report_type_label',
        elementType: 'select',
        data: [
          {
            value: 'report-1',
            label: 'Payment report'
          }
        ],
        valueField: 'value',
        textField: 'label',
        defaultValue: {
          value: 'report-1',
          label: 'Payment report'
        }
      },
      practitioners: {
        id: 'practitioner',
        translateLabelKey: 'report_practitioner_label',
        elementType: 'select',
        data: addPractitionerLocalization,
        defaultValue:
          practitionersList.find(el => el.id === defaultPractitionerId) || practitionersList[0],
        valueField: 'id',
        textField: 'name'
      },
      locations: {
        id: 'locations',
        translateLabelKey: 'locations',
        elementType: 'select',
        data: parseCampuses,
        defaultValue:
          parseCampuses.find(el => el.id === defaultCampusId) ||
          defaultCampus ||
          parseCampuses[0],
        valueField: 'id',
        textField: 'name'
      },
      date: {
        id: 'date',
        translateLabelKey: 'Date',
        elementType: 'datePiker',
        selected:
          defaultDate && moment(defaultDate).isValid() ? moment(defaultDate) : moment().local(),
        readOnly: true,
        dateFormat: 'DD.MM.YYYY dddd'
      }
    };
  }
};

//──── PDF ───────────────────────────────────────────────────────────────────────────────
export const parseFilterParams = filterObj => ({
  practitionerId: filterObj.practitioners,
  locationId: filterObj.locations,
  dateTime: filterObj.date
});

export const generatePDF = filterObj => {
  const params = parseFilterParams(filterObj);
  return new Promise((resolve, reject) => {
    paymentApi
      .get('/invoices/statistics/pdf', {
        params: { ...params },
        responseType: 'blob',
        withoutLoader: true
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response }) => {
        if (response && response.status !== 400 && response.status !== 401) {
          reject();
        }
      });
  });
};

export const savePdf = data => {
  const { generateDate, blob } = data;
  if (blob && generateDate) {
    const fileName = `Report_${moment(generateDate).format('DD.MM.YY_HH.mm')}`;
    FileSaver.saveAs(blob, `${fileName}.pdf`);
  }
};
